import { format, parse, parseISO, isValid } from "date-fns";

export const ToDateBR = (date) => {
  if (!date) return "";

  try {
    const parsedDate =
      typeof date === "string" ? parseISO(date) : new Date(date);
    if (!isValid(parsedDate)) return "";
    return format(parsedDate, "dd/MM/yy");
  } catch (error) {
    return "";
  }
};

export const toDateTime = (value) => {
  if (!value || value === "N/A") return "N/A";

  try {
    const parsedDate =
      typeof value === "string" ? parseISO(value) : new Date(value);
    if (!isValid(parsedDate)) return "N/A";
    return format(parsedDate, "dd/MM/yyyy HH:mm:ss");
  } catch (error) {
    return "N/A";
  }
};

export const toDate = (value) => {
  if (!value || value === "N/A") return "N/A";

  if (value.includes("*")) {
    const year = value.split("*")[0];
    return `**/**/${year}`;
  }

  try {
    const parsedDate =
      typeof value === "string" ? parseISO(value) : new Date(value);
    if (!isValid(parsedDate)) return "N/A";
    return format(parsedDate, "dd/MM/yyyy");
  } catch (error) {
    return "N/A";
  }
};

export const GetInitials = (full_name = "") => {
  if (!full_name || typeof full_name !== "string") return "";

  const splited_name = full_name.toUpperCase().split(" ");

  const first_name = splited_name[0];
  if (splited_name.length === 1) return first_name[0];

  const last_name = splited_name[splited_name.length - 1];

  return `${first_name[0]}${last_name[0] ?? ""}`;
};

export const formatSelectOptions = (array, labelSelector, valueSelector) => {
  return array.map((item) => {
    return {
      label:
        typeof labelSelector === "string"
          ? item[labelSelector]
          : labelSelector(item),
      value:
        typeof valueSelector === "string"
          ? item[valueSelector]
          : valueSelector(item),
    };
  });
};

export const cpfCnpjMask = (value) => {
  if (!value) return "";

  let result;

  if (value.length < 14 || (value.length <= 14 && value.includes("."))) {
    result = value
      .replace(/\D/g, "")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})/, "$1-$2")
      .replace(/(-\d{2})\d+?$/, "$1");
  } else {
    result = value
      .replace(/\D/g, "")
      .replace(/(\d{2})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1/$2")
      .replace(/(\d{4})(\d)/, "$1-$2")
      .replace(/(-\d{2})\d+?$/, "$1");
  }

  return result;
};

export const defaultCurrencyMask = (value) => {
  if (!value) return "";

  value = value.toString();

  value = value.replace(",", ".");

  const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 };

  const result = new Intl.NumberFormat("pt-BR", options).format(
    parseFloat(value),
  );

  return result;
};

export const currencyMask = (value) => {
  if (!value) return "";

  value = value.replace(".", "").replace(",", "").replace(/\D/g, "");

  const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
  const result = new Intl.NumberFormat("pt-BR", options).format(
    parseFloat(value) / 100,
  );

  return result;
};

// Locale padrão pt-BR: as máscaras (currencyMask/defaultCurrencyMask) sempre
// formatam em pt-BR ("1.234,56"), então o parse precisa usar os mesmos
// separadores independentemente do locale do navegador do usuário. Sem isso,
// em navegadores com locale != pt-BR o valor era parseado errado (ex.: saldo
// "2.000,00" virava 2, ou "12,30" virava 1230) e a alteração "não salvava".
export const parseLocaleNumber = (stringNumber, locale = "pt-BR") => {
  if (!stringNumber) return 0;

  var thousandSeparator = Intl.NumberFormat(locale)
    .format(11111)
    .replace(/\p{Number}/gu, "");
  var decimalSeparator = Intl.NumberFormat(locale)
    .format(1.1)
    .replace(/\p{Number}/gu, "");

  stringNumber = stringNumber.toString();

  return parseFloat(
    stringNumber
      .replace(new RegExp("\\" + thousandSeparator, "g"), "")
      .replace(new RegExp("\\" + decimalSeparator), "."),
  );
};

export const convertToInternationalCurrencySystem = (value) => {
  return Math.abs(Number(value)) >= 1.0e9
    ? (Math.abs(Number(value)) / 1.0e9).toFixed(0) + "B"
    : Math.abs(Number(value)) >= 1.0e6
      ? (Math.abs(Number(value)) / 1.0e6).toFixed(0) + "M"
      : Math.abs(Number(value)) >= 1.0e3
        ? (Math.abs(Number(value)) / 1.0e3).toFixed(0) + "K"
        : Math.abs(Number(value));
};

export const formatNumDecimalSeparator = (strOrNum) => {
  if (strOrNum == null) return;
  return strOrNum.toString().replace(/,/g, ".");
};

export const formatToURL = (string) => {
  const regex = /[^A-Za-z0-9_.\-~]/g;

  return string
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(regex, "")
    .toLowerCase();
};

export const transformIntoArrayOptions = (arr, value, label) => {
  if (Array.isArray(arr)) {
    return arr.map((item) => {
      return {
        value: item[value],
        label: item[label],
      };
    });
  }
};

export const formatCurrency = (strOrNum, withSymbol = true) => {
  const value = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
  }).format(parseFloat(strOrNum || 0));

  if (!withSymbol) return value.replace("R$", "");

  return value;
};

export const cpfcnpjMask = (value) => {
  if (!value) return "";

  let result;

  if (value.length < 14 || (value.length <= 14 && value.includes("."))) {
    result = value
      .replace(/[^\d*]/g, "")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})/, "$1-$2")
      .replace(/(-\d{2})\d+?$/, "$1");
  } else {
    result = value
      .replace(/[^\d*]/g, "")
      .replace(/(\d{2})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1/$2")
      .replace(/(\d{4})(\d)/, "$1-$2")
      .replace(/(-\d{2})\d+?$/, "$1");
  }

  return result;
};

export const phoneMask = (value) => {
  if (!value) return "";

  value = value.replace(/[^\d]/g, "");

  return value.replace(/^(\d{2})(\d{5})(\d{4}).*/, "($1) $2-$3");
};

export const inputMasks = {
  document: "999.999.999-99",
  phone: "+99 99 99999-9999",
  birth_date: "99/99/9999",
  cep: "99999-999",
};

export const formatValueByUnitType = (value, unit_type) => {
  if (!unit_type || value == null || Number.isNaN(Number(value))) return value;

  switch (unit_type) {
    case "NUMBER":
      return new Intl.NumberFormat("pt-BR", {
        maximumFractionDigits: 2,
      }).format(value);

    case "MONEY":
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        maximumFractionDigits: 2,
      }).format(value);

    case "PERCENTAGE":
      return `${new Intl.NumberFormat("pt-BR", {
        maximumFractionDigits: 2,
      }).format(value)}%`;

    default:
      return value;
  }
};

export const parseDateExcel = (excelTimestamp) => {
  const secondsInDay = 24 * 60 * 60;
  const excelEpoch = new Date(1899, 11, 31);
  const excelEpochAsUnixTimestamp = excelEpoch.getTime();
  const missingLeapYearDay = secondsInDay * 1000;
  const delta = excelEpochAsUnixTimestamp - missingLeapYearDay;
  const excelTimestampAsUnixTimestamp = excelTimestamp * secondsInDay * 1000;
  const parsed = excelTimestampAsUnixTimestamp + delta;
  return isNaN(parsed) ? null : parsed;
};

export const globalInterpreterForDate = (possibleDate) => {
  if (!possibleDate) return "";

  const dateIsString = typeof possibleDate === "string";
  const dateIsNumber = typeof possibleDate === "number";

  const americanDashDateRegex = /^\d{4}-\d{2}-\d{2}$/; //YYYY-MM-DD
  const americanSlashDateRegex = /^\d{4}\/\d{2}\/\d{2}$/; //YYYY/MM/DD
  const brasilianDashDateRegex = /^\d{2}-\d{2}-\d{4}$/; //DD-MM-YYYY
  const brasilianSlashDateRegex = /^\d{2}\/\d{2}\/\d{4}$/; //DD/MM/YYYY

  const isValidTimestamp = !isNaN(new Date(possibleDate).getTime());

  const isValidExcelDate = (excelDate) => {
    if (excelDate < 1 || excelDate > 2958465) {
      return false;
    }
    const excelEpoch = new Date(Date.UTC(1899, 11, 30));
    const jsDate = new Date(excelEpoch.getTime() + excelDate * 86400000);

    return !isNaN(jsDate.getTime());
  };

  try {
    if (dateIsString) {
      if (americanDashDateRegex.test(possibleDate)) {
        const parsed = parse(possibleDate, "yyyy-MM-dd", new Date());
        return isValid(parsed) ? parsed : "";
      }

      if (americanSlashDateRegex.test(possibleDate)) {
        const parsed = parse(possibleDate, "yyyy/MM/dd", new Date());
        return isValid(parsed) ? parsed : "";
      }

      if (brasilianDashDateRegex.test(possibleDate)) {
        const parsed = parse(possibleDate, "dd-MM-yyyy", new Date());
        return isValid(parsed) ? parsed : "";
      }

      if (brasilianSlashDateRegex.test(possibleDate)) {
        const parsed = parse(possibleDate, "dd/MM/yyyy", new Date());
        return isValid(parsed) ? parsed : "";
      }
    }

    if (dateIsNumber) {
      if (isValidExcelDate(possibleDate)) {
        const excelDate = parseDateExcel(possibleDate);
        return excelDate ? new Date(excelDate) : "";
      }

      if (isValidTimestamp) {
        return new Date(possibleDate);
      }
    }

    return "";
  } catch (error) {
    return "";
  }
};
